// Sliding text block schema - Infinite horizontal scrolling text marquee
export const slidingTextSchema = {
  type: 'sliding-text',
  label: 'Sliding Text',
  description: 'Scrolling text marquee with multiple items',
  icon: 'MoveHorizontal',
  defaultContent: {
    items: ['Welcome', 'Chess Coach', 'Learn & Improve'],
    speed: 'normal', // 'slow' | 'normal' | 'fast'
    separator: '•',
    textColor: '#ffffff',
    backgroundColor: '#749555',
    style: {},
  },
  fields: [
    { name: 'items', label: 'Text Items', type: 'array' },
    { name: 'speed', label: 'Speed', type: 'select' },
    { name: 'separator', label: 'Separator', type: 'text' },
    { name: 'textColor', label: 'Text Color', type: 'color' },
    { name: 'backgroundColor', label: 'Background Color', type: 'color' },
  ],
};
